import ReactOnRails from 'react-on-rails';

import Index from '../bundles/Home/components/Index';

// This is how react_on_rails can see the Home in the browser.
ReactOnRails.register({
  Index
});
